import React from 'react';
import styled from 'styled-components';

// import { Select } from '@ge/components/select';
import { Loader } from '@ge/components/loader';
import { ScrollingContainer } from '@ge/components/scrolling-container';
import { useContractualReportingOverview } from '@ge/feat-analyze/data-hooks/use-contractual-reporting-overview';

import { SitePanel } from './site-panel';
import { SitesHeader } from './sites-header';

const MAContainer = styled.div`
  margin: 20px 50px;
`;

// const SiteSortSelect = styled(Select)`
//   margin-bottom: 15px;
// `;

const StyledScrollingContainer = styled(ScrollingContainer)`
  display: flex;
  position: relative;
  flex: 1;
  height: calc(100vh - 270px);
  width: 100%;
`;

export const Sites = () => {
  const { isLoading: isOverviewLoading, data: overviewData } = useContractualReportingOverview();

  if (isOverviewLoading) {
    return <Loader />;
  }

  return (
    <MAContainer>
      <SitesHeader overviewData={overviewData} />
      <StyledScrollingContainer relative>
        {overviewData?.bySite.map((site) => (
          <SitePanel key={site.site?.id} siteData={site} isOverviewLoading={isOverviewLoading} />
        ))}
      </StyledScrollingContainer>
    </MAContainer>
  );
};
